/**
 * Employee auth token management via localStorage.
 * This bypasses cookie-based auth which can be blocked by browsers.
 */

const TOKEN_KEY = "darkhorse_employee_token";

export function getEmployeeToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setEmployeeToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    console.warn("[Auth] Failed to save token to localStorage");
  }
}

export function clearEmployeeToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

export function hasEmployeeToken(): boolean {
  return !!getEmployeeToken();
}
